import React, { ReactElement } from 'react';
import { startCase } from 'lodash';
import {
  IconRatingEmojiNegative,
  IconRatingEmojiNeutral,
  IconRatingEmojiPositive,
} from 'components/Icons';
import Typography from 'components/Typography';
import { useAnalytics } from 'hooks/useAnalytics';

import { CHAT_UI_PREFIX } from 'constants/id';
import { ANALYTICS } from 'analytics/constants';

import { TileProps } from './types';
import { RatingsType } from '../types';
import { AnalyticClickedDetailsType } from 'analytics/types';
import { Icon, Label, Tile as StyledTile } from './styles';

const BaseTile = (props: TileProps & { rating: RatingsType; icon: ReactElement }): ReactElement => {
  const { selected = false, disabled = false, onClick, icon, rating } = props;
  const { trackEvent } = useAnalytics();

  const tProps = {
    disabled: disabled || selected,
    selected,
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      trackEvent({
        analyticEvent: ANALYTICS.EVENT.CLICKED,
        details: {
          analytic_click_id: `${CHAT_UI_PREFIX}-rating-request-tile`,
          content: startCase(rating),
        } as AnalyticClickedDetailsType,
      });
      onClick(e);
    },
    className: selected ? 'selected' : undefined,
  };

  return (
    <StyledTile {...tProps} id={`rating-request-tile-${rating}`}>
      <Tile.Icon>{icon}</Tile.Icon>
      <Tile.Label>
        <Typography size='md' variant='label'>
          {rating}
        </Typography>
      </Tile.Label>
    </StyledTile>
  );
};

const Tile = (props: TileProps): ReactElement => {
  const { rating } = props;
  const ratings: { [key in RatingsType]: ReactElement } = {
    poor: <BaseTile {...props} icon={<IconRatingEmojiNegative />} />,
    average: <BaseTile {...props} icon={<IconRatingEmojiNeutral />} />,
    great: <BaseTile {...props} icon={<IconRatingEmojiPositive />} />,
  };
  return ratings[rating];
};

Tile.Icon = Icon;
Tile.Label = Label;

export default Tile;
